import React from "react";
import { FieldComponent } from "./fields/FieldComponent";
import { useFluidForm } from "./FormContext";
import { isArrayElement, isObjectElement } from "../../../shared";
import { ComposedListFieldComponent } from "./fields/ComposedListField.component";
import { useRenderViewChange } from "./common";
export const FluidFormFields = ({ field, options }) => {
    const configService = useFluidForm();
    // Get the form columns setting
    const formColumns = configService.getAdditionalConfigValue("styleConfig", "formColumns") || "2";
    let config = configService.getConfig(field.configName);
    useRenderViewChange(field.fieldPath);
    if (!field.type || !field.key) {
        return null;
    }
    if (isObjectElement(field, configService.getConfigMap())) {
        let values = field.value;
        let formFields = [];
        let label = config.label;
        let fields = Object.entries(values).filter(([key, value]) => value.active !== false);
        // Calculate grid columns based on formColumns setting
        const totalColumns = parseInt(formColumns) || 2;
        // Use a mapping object for the grid column classes
        const gridColClasses = {
            1: "grid-cols-1",
            2: "grid-cols-1 @xl/fluid-form-container:grid-cols-2",
            3: "grid-cols-1 @xl/fluid-form-container:grid-cols-2 @2xl/fluid-form-container:grid-cols-3"
        };
        const gridColsClass = gridColClasses[totalColumns] || gridColClasses[2]; // Default to 2 columns
        for (let [key, value] of fields) {
            let itemConfig = configService.getConfig(value.configName);
            // Calculate column span based on field type and total columns
            let colSpanClass = ``;
            if (!itemConfig.styles?.colSpan && (itemConfig.type === "composedList" || itemConfig.type === "section" || itemConfig.type == "composed")) {
                // Full width for composed and section fields
                colSpanClass = `col-span-full`;
            }
            if (itemConfig.styles?.colSpan) {
                let colSpan = itemConfig.styles.colSpan;
                if (colSpan == "full") {
                    colSpanClass = `col-span-full`;
                }
                else {
                    colSpanClass = `col-span-${colSpan}`;
                }
            }
            formFields.push(React.createElement("div", { key: key, className: colSpanClass },
                React.createElement(FluidFormFields, { key: key, field: value, options: options })));
        }
        return (React.createElement(React.Fragment, null,
            label && !options?.hideTitle && React.createElement("h2", { className: `fluid-form-title ${config.type}` }, config.label),
            React.createElement("div", { className: `grid ${gridColsClass} gap-3 sm:gap-5 mb-4 sm:mb-6 fluid-form-fields justify-center items-center text-center` }, formFields)));
    }
    else if (isArrayElement(field, configService.getConfigMap())) {
        return (React.createElement(ComposedListFieldComponent, { key: field.fieldPath, fieldPath: field.fieldPath, options: options }));
    }
    else {
        return React.createElement(FieldComponent, { key: field.fieldPath, fieldPath: field.fieldPath, options: options });
    }
};
